import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FormatItalic = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M21.087 6h-6.175c-0.504 0-0.912 0.408-0.912 0.913v0.174c0 0.505 0.408 0.913 0.912 0.913h1.785l-2.423 16h-2.362c-0.504 0-0.912 0.408-0.912 0.913v0.174c0 0.505 0.408 0.913 0.912 0.913h6.175c0.504 0 0.913-0.408 0.913-0.913v-0.174c0-0.505-0.41-0.913-0.913-0.913h-1.792l2.425-16h2.367c0.504 0 0.913-0.408 0.913-0.913v-0.174c0-0.505-0.41-0.913-0.913-0.913z" />
  </SvgIcon>
);

export default FormatItalic;
